'use client'
import { RaHeading, RaImage, RaTypography } from '@components/core/index.core'

import { useSettings } from '@contexts/settings.context'
import { ThemeSettings } from '@typings'
import { useMemo } from 'react'

export const RaTravelGuides = () => {
  const { themeSettings } = useSettings()
  const travelGuides: ThemeSettings['travel_guides'] =
    themeSettings.travel_guides

  if (!travelGuides) return null

  const polaroidContent = useMemo(() => {
    if (!travelGuides.job_title) return null
    return (
      <>
        <RaHeading
          noPadding
          component="h4">
          {travelGuides.job_title}
        </RaHeading>
        <RaTypography
          component="span"
          align="center">
          {travelGuides.name}
        </RaTypography>
      </>
    )
  }, [travelGuides])

  return (
    <RaImage
      image={travelGuides.image}
      polaroid
      polaroidContent={polaroidContent}
      rotate="right"
    />
  )
}
